import { render, staticRenderFns } from "./RouteForm.vue?vue&type=template&id=6100a67c"
import script from "./RouteForm.vue?vue&type=script&lang=js"
export * from "./RouteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6100a67c')) {
      api.createRecord('6100a67c', component.options)
    } else {
      api.reload('6100a67c', component.options)
    }
    module.hot.accept("./RouteForm.vue?vue&type=template&id=6100a67c", function () {
      api.rerender('6100a67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-routes-options/RouteForm.vue"
export default component.exports